import type { Node } from "@xyflow/react";
import { type ExplodeNodeData, NodeKind } from "../../types";

export const graphNode = (
    id: string,
    x: number,
    y: number,
    data: ExplodeNodeData,
    zIndex = 0,
): Node<ExplodeNodeData> => ({ id, type: NodeKind.BUCKET, position: { x, y }, data, zIndex });
